import { CSV, HIGHCHARTS_MENU, PNG, QAndAAnsweredOptions, XLS } from '../../Utils/Constants';
import i18n from '../../Utils/i18n';

export function getChartTypeMenuItems(menuType) {
  let menuItems = [];
  if (HIGHCHARTS_MENU === menuType.toUpperCase()) {
    menuItems.push(
      {
        title: i18n.t('report.format.png'),
        iconClass: 'icon png',
        id: PNG
      },
      {
        title: i18n.t('report.format.excel'),
        iconClass: 'icon xls',
        id: XLS
      },
      {
        title: i18n.t('report.format.csv'),
        iconClass: 'icon csv',
        id: CSV
      }
    );
  }
  return menuItems;
}

export function getReportTypeMenuItems() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('report.format.excel'),
      iconClass: 'icon xls',
      id: XLS
    },
    {
      title: i18n.t('report.format.csv'),
      iconClass: 'icon csv',
      id: CSV
    }
  );
  return menuItems;
}

export function getQAndAMenuItems() {
  return [
    {
      title: i18n.t('engagement.allPosts'),
      id: QAndAAnsweredOptions.ALL_POSTS
    },
    {
      title: i18n.t('engagement.unanswered'),
      id: QAndAAnsweredOptions.UNANSWERED
    },
    {
      title: i18n.t('engagement.answered'),
      id: QAndAAnsweredOptions.ANSWERED
    }
  ];
}



// WEBPACK FOOTER //
// ./src/Components/Menu/MenuItemsHelper.js